// El backend firma los JWT con los nombres de claim clásicos de WS-Federation/.NET
// (no con las abreviaturas cortas tipo "nameid"). Único lugar que conoce el nombre
// real del claim de id de usuario, para no repetir el string largo en cada archivo
// que decodifica el token.
const NAME_IDENTIFIER_CLAIM =
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier";

export const getUserIdFromDecodedToken = (decoded) => {
  if (!decoded) return null;
  return decoded[NAME_IDENTIFIER_CLAIM] ?? decoded.nameid ?? null;
};
